module.exports = __webpack_public_path__ + "static/media/Login_Icon.4c2b2231.png";